// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cq-j";
export var fulfillmentFormRail = "_cq-i";
export var headerTitleRow = "_cq-l";
export var orderDetailsWrapper = "_cq-g";
export var orderLinkTrigger = "_cq-2";
export var paymentInformationGrid = "_cq-q";
export var paymentSummaryColumn = "_cq-r";
export var phoneShipmentPickerButton = "_cq-e";
export var phoneShipmentPickerButtonContent = "_cq-f";
export var phoneShipmentPickerButtonWrapper = "_cq-d";
export var phoneShipmentPickerTrigger = "_cq-c";
export var shipmentContainer = "_cq-k";
export var shipmentDetailsMainPane = "_cq-h";
export var shipmentNavigationCard = "_cq-a";
export var shipmentNavigationEdgeTrigger = "_cq-6";
export var shipmentNavigationRail = "_cq-3";
export var shipmentNavigationRailEnter = "_cq-5";
export var shipmentNavigationRailHeader = "_cq-9";
export var shipmentNavigationRailOverlay = "_cq-4";
export var shipmentNavigationScrim = "_cq-7";
export var shipmentSummaryFact = "_cq-n";
export var shipmentSummaryGrid = "_cq-m";
export var shipmentSummaryMetadataRow = "_cq-o";
export var shipmentSummaryTags = "_cq-p";
export var shipmentWorkspace = "_cq-0";
export var shipmentWorkspaceBodyTablet = "_cq-8";
export var shipmentWorkspaceContent = "_cq-b";
export var shipmentWorkspaceHeader = "_cq-1";